import LandingPage from './landingpage';
export default LandingPage;